if ($('.fade-item').length > 0) {


    function onEntry(entries, index) {
        entries.forEach(function (entry, index) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("is-showing");
            } else {
                entry.target.classList.remove("is-showing");
            }
        });
    }

    var options = {};

    var observer = new IntersectionObserver(onEntry, options);

    var items = document.querySelectorAll(".fade-item");

    items.forEach(function (item, index) {
        (index % 2) ? item.classList.add('fade-left') : item.classList.add('fade-right');
    });

    items.forEach(function (item, index) {
        observer.observe(item);
    });


}



/* =======================================

	            USER ACCOUNTS

======================================= */

//  Initialize registration form to make hashed email available for tracking
$(function(){
    window.dataLayer = window.dataLayer || [];

    // UTILITIES
    function getCookie(cookieName) {
        let regStr = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$',
        regEx = new RegExp(regStr);
        return document.cookie.replace(regEx, '$1');
    }
    async function hashValue(val) {
        if (!val) return null;
        const utf8 = new TextEncoder().encode(val.toLowerCase());
        const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
            .map((bytes) => bytes.toString(16).padStart(2, '0'))
            .join('');
        return hashHex;
    }

    // Get klavyio ID for tracking
    var user_id = getCookie('__kla_id');
    window.dataLayer.push({ user_id: user_id });

    // Prep email hash for tracking -- this is for use on the registration form
    var emailEl = document.getElementById('customer_email');
    if (emailEl) {
        emailEl.addEventListener('change', async function() {
            var hashedEmail = await hashValue(emailEl.value);
            window.dataLayer.push({ email: hashedEmail });
        });
    }

    // Additionally, check to see if the user is logged in already, and on an
    // account page. If so, hash the email and push to the dataLayer.
    var loginEl = document.querySelector('.logged-in-as');
    if (loginEl) {
        var email = loginEl.dataset?.email;
        hashValue(email).then(hashedEmail => {
            window.dataLayer.push({ email: hashedEmail });
        });
    }

});


/* =======================================

	            MINI - CART

======================================= */


$(function () {

    $('.header-cart-link').on('click', function (e) {
        e.preventDefault();

        $.getJSON('/cart.js', function (data) {

            // run template view
            var template = $("#minicart-template").html();
            var tmpl = _.template(template);

            // populate cart data
            $("#mini-cart").html(tmpl({ cart: data }));

            // format all prices
            $('.price', '#mini-cart').each(function () {
                $(this).html(Shopify.formatMoney($(this).text()));
            });

            $(".qty_input").on('change', function () {
                updateCartQuantity($(this).data('productId'), $(this).val());
            });

            $('.item-remove').on('click', function () {
                removeItemFromCartByLineNumber($(this).parents('.row-item').data('lineNumber'));
            });

            $('.close-link').on('click', function () {
                $('#mini-cart').removeClass('drawer--is-open ').addClass('drawer--is-closed');
            });

            $('#mini-cart').addClass('drawer--is-open').removeClass('drawer--is-closed');
        });

    });
    $('body').click( function(){
        $('#mini-cart').removeClass('drawer--is-open ').addClass('drawer--is-closed');
    });
    function updateCartQuantity(productId, qty) {
        if (qty === 0 || qty === "0") {
            removeItemFromCart(productId);
        } else {
            changeCartAjax(qty, productId)
        }
    }

    function removeItemFromCart(productId) {
        $('.row-item[data-row-id=row-' + productId + ']').fadeOut();
        changeCartAjax(0, productId)
    }

    function removeItemFromCartByLineNumber(lineNumber) {
        $('.row-item[data-line-number' + lineNumber + ']').fadeOut();
        changeCartAjaxLineNumber(0, lineNumber)
    }

    function changeCartAjax(qty, productId) {
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                'quantity': qty,
                'id': productId
            },
            dataType: 'json',
            success: function (result) {
                updateMiniCart(result);
            }
        });
    }

    function changeCartAjaxLineNumber(qty, lineNumber) {
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                'quantity': qty,
                'line': lineNumber
            },
            dataType: 'json',
            success: function (result) {
                updateMiniCart(result);
            }
        });
    }

    function updateMiniCart(data) {
        var qty = data.item_count;
        var subTotal = Shopify.formatMoney(data.total_price);
        $("#mini-cart-subtotal").html(subTotal);
        $("#mini-cart-qty").html(qty);
        if (qty === 0 || qty === "0") {
            $(".header-cart-count").removeClass('active');
        }
    }

});


/* =======================================

	            FAQ - Page

======================================= */

var slug = function (str) {
    var $slug = '';
    var trimmed = $.trim(str);
    $slug = trimmed.replace(/[^a-z0-9-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    return $slug.toLowerCase();
}

if ($(".s4com-helpcenter").length) {

    //Wrap category links
    $(".s4com-space-bottom > a").each(function (i) {
        var catName = slug($(this).find('h3').html());
        $(this).wrap("<div class='faq-category' data-category='" + catName + "'></div>");
        $(this).parent().next().attr('data-category', catName);
    });

    //Create Category dropdown
    $(".s4com-panel").before('<select class="faq-category-drop"></select>');

    //Append the categories
    var categories = $(".faq-category > a > h3").map(function () {
        return $(this).html();
    }).get();

    var option = '<option value="all">All Categories</option>';
    for (var i = 0; i < categories.length; i++) {
        option += '<option value="' + slug(categories[i]) + '">' + categories[i] + '</option>';
    }

    $('.faq-category-drop').append(option);

    $(".faq-category-drop").on('change', function () {

        $(".faq-category, .s4com-section-body").show();
        var selected = $(this).val();
        if (selected !== 'all') {
            $(".faq-category[data-category!='" + selected + "']").fadeOut();
            $(".s4com-section-body[data-category!='" + selected + "']").fadeOut();
        }
    });


}


/* =======================================

	            PRODUCT PAGE

======================================= */

(function () {
    var video = $('.video-modal');
    var button = $('.modal-reveal');

    $(button).on('click', function () {
        $(video).toggleClass('is-open');
    })

})();

if ($(".product-options").length > 0) {
    $(".variant.color--option").each(function () {
        variant_color = this.dataset.color;
        this.style.background = getVariantBkg(variant_color);
    })
}

function getVariantBkg(vColor) {

    colors = vColor.split(',');

    if (colors.length > 1) {
        var stripe = (100 / colors.length);
        var gradient = 'linear-gradient(90deg, ';
        var x = 1;

        for (i = 0; i < colors.length - 1; i++) {

            var start = colors[i] + ' ' + (stripe * x) + '%, ';
            var end = colors[i + 1] + ' ' + (stripe * (x)) + '%, ';

            gradient += start;
            gradient += end;
            x++;
        }
        gradient += colors[colors.length - 1] + ' 100%)';
        return gradient;
    } else {
        return colors[0];
    }
}

if (window.location.href.indexOf("#product-reviews") > -1) {
    $('html, body').animate({
        scrollTop: $('#product-reviews').offset().top
    }, 2500);

}

//Shipment Restrictions
if ($("#shipment_restriction").length > 0) {
    if ($("#shipment_restriction").val() === 'GEOLOCATE') {
        isCustomerInCA();
    } else if ($("#shipment_restriction").val() === 'SHOW_POPUP') {
        showShipmentRestrictionPopUp();
    }
}

function isCustomerInCA() {
    if ("geolocation" in navigator) {
        // check if geolocation is supported/enabled on current browser
        navigator.geolocation.getCurrentPosition(
            function success(position) {
                var latitude = position.coords.latitude;
                var longitude = position.coords.longitude;

                $.ajax({
                    type: "GET",
                    url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=AIzaSyBPWoltKOC-DDboUyP-OqC3kveL_psicSY',
                    async: true,
                    success: function (response) {
                        if (response.status === 'OK' && response.results.length) {
                            results = response.results[0].address_components;
                            var state = findResult(results, "administrative_area_level_1");
                            var country = findResult(results, "country");
                            if (state === 'CA' && country === 'US') {
                                showShipmentRestrictionPopUp();
                            }
                        }
                    }
                });
            }
        );
    }
}

function findResult(results, name) {
    var result = $.map(results, function (obj) {
        if (obj.types[0] == name && obj.types[1] == "political") {
            return obj.short_name;
        }
    });

    return result[0];
};

function showShipmentRestrictionPopUp() {
    $('#shipment_restriction_modal').plainModal('open')
        .on('plainmodalbeforeclose', function (event) {
            var from = event.from;
            if (from.type === 'click' && from.currentTarget.className === 'plainmodal-overlay') {
                event.preventDefault();
            }
        });
}

/* =======================================

	            How It Works

======================================= */

$(document).ready(function () {

    if ($(".module-how-it-works-tabs").length > 0) {
        setActiveTab();

        // Variables
        var clickedTab = $(".tabs > .active");
        var tabWrapper = $(".tab__content");
        var activeTab = tabWrapper.find(".active");
        var activeTabHeight = activeTab.outerHeight();
        // Set height of wrapper on page load
        tabWrapper.height(activeTabHeight);

        window.wasScrolled = false;
        $(window).scroll(function () {
            if (!window.wasScrolled) {
                tabWrapper.height(activeTab.outerHeight());
                window.wasScrolled = true;
            }
        });

        // Show tab on page load
        activeTab.show();

        $(".tabs > li").on("click", function () {

            // Remove class from active tab
            $(".tabs > li").removeClass("active");

            // Add class active to clicked tab
            $(this).addClass("active");

            // Update clickedTab variable
            clickedTab = $(".tabs .active");

            // fade out active tab
            activeTab.fadeOut(250, function () {

                // Remove active class all tabs
                $(".tab__content > li").removeClass("active");

                // Get index of clicked tab
                var clickedTabIndex = clickedTab.index();

                // Add class active to corresponding tab
                $(".tab__content > li").eq(clickedTabIndex).addClass("active");

                // update new active tab
                activeTab = $(".tab__content > .active");

                // Update variable
                activeTabHeight = activeTab.outerHeight();

                // Animate height of wrapper to new tab height
                tabWrapper.stop().delay(50).animate({
                    height: activeTabHeight
                }, 500, function () {

                    // Fade in active tab
                    activeTab.delay(50).fadeIn(250);

                });
            });
        });

        $(".hiw .related-products-carousel").slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

});

function setActiveTab() {

    var param = getURLParam('show-tab');
    if (param !== null) {
        if ($(".tabs > li[data-tab-id=" + param + "]").length > 0) {
            $(".tabs > li").removeClass("active");
            $(".tabs > li[data-tab-id=" + param + "]").addClass('active');

            $(".tab__content > li").removeClass("active");
            $(".tab__content > li[data-tab-id=" + param + "]").addClass('active');
        }
    }

}

function getURLParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}
/* =======================================

	           Search

======================================= */

$(document).ready(function () {
    $(".fa-search").click(function () {
        $(".searchForm").toggleClass("active");
    });

    $(".footer-menu-title:contains('Media')").addClass('footer-menu-title-link');
    $(".footer-menu-title:contains('Media')").on('click', function () {
        window.location.href = 'https://thermacellrepellents.myshopify.com/pages/media-download';
    });
});

/* =======================================

	    International Portal

======================================= */

$(document).ready(function () {
    $(".forms-toogle-link").click(function () {
        $(".recover-password").toggle();
        $(".customer-login").toggle();
    })
});


/* =======================================

	    Testimonial Swipe

======================================= */

var mySwiper = new Swiper('.swiper-container', {
    loop: true,
    loopAdditionalSlides: 3,    //<-- This one

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
    },


    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});


/* =======================================

	         Radius Swiper

======================================= */

var radiusSwiper = new Swiper('.radius-swiper-container', {
    loop: true,
    loopAdditionalSlides: 3,    //<-- This one

    // If we need pagination
    pagination: {
        el: '.radius-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
    },


    // Navigation arrows
    navigation: {
        nextEl: '.radius-swiper-button-next',
        prevEl: '.radius-button-prev',
    },
});


/* =======================================

	         Manage Preferences

======================================= */

$("#submit-manage-preference-form").on('click', function (event) {

    event.preventDefault();
    var site_id = $("#site_id").val();
    var webform_id = $("#webform_id").val();
    var shared_secret = $("#shared_secret").val();
    var base_url = $("#base_url").val();
    var email_m_p = $("#email_manage_p").val();

    var hash = CryptoJS.HmacSHA256(site_id + webform_id + email_m_p, shared_secret);
    var final_url = base_url + '/' + webform_id + '/' + site_id + '/manpref/' + email_m_p + '/' + hash;

    $(".preference-form").hide();
    $("#iframe-container").html('<iframe class="preferences-iframe" src="' + final_url + '"></iframe>');
    $("#iframe-container").show();

});



/* =======================================

	         Headroom Init

======================================= */

// grab an element
var myElement = document.querySelector(".header");
// construct an instance of Headroom, passing the element
var headroom = new Headroom(myElement);
// initialise
headroom.init();

/* =======================================

	            Home Page

======================================= */


if ($(".rating-stars-wrapper").length > 0) {


    var url = "//api.bazaarvoice.com/data/products.json?apiversion=5.4&passkey=ca6qyfDLykRniMh4RUK54h1OR23zYQSBtrzBvnPZ5ilGU&stats=reviews&filter=totalreviewcount:gte:1&excludeFamily=true&limit=100";

    $.getJSON(url, function (data) {

        var totalReviews = 0;
        var stars = {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0
        };

        $.each(data.Results, function (key, val) {
            totalReviews += data.Results[key].ReviewStatistics.TotalReviewCount;
            var distributions = data.Results[key].ReviewStatistics.RatingDistribution;
            for (var i = 0; i < distributions.length; i++) {
                stars[distributions[i].RatingValue] = stars[distributions[i].RatingValue] + distributions[i].Count;
            }

        });

        var arrStars = Object.keys(stars).map(function (key) { return stars[key]; });
        var pStars = 0;
        for (var s = 0; s < arrStars.length; s++) {

            var perc = Math.round((arrStars[s] * 100) / totalReviews);

            $("#" + (s + 1) + "-stars-bar").attr("style", "width:" + perc + "%");
            $("#" + (s + 1) + "-stars").html(perc + "%");
            pStars += (arrStars[s] * (s + 1));

        }

        var finalAVG = pStars / totalReviews;
        var width = 100 / (5 / finalAVG);

        $('.rating-stars-slider').width(width + '%');
        $(".avg-rating").html(Math.round(finalAVG * 10) / 10);
        $(".t-avg").html(Math.round(finalAVG * 10) / 10);
        $(".q-reviews").html(totalReviews);


        //Tooltip
        $('.tooltip').tooltipster({
            trigger: 'custom',
            triggerOpen: {
                mouseenter: true,
                touchstart: true,
                click: true
            },
            triggerClose: {
                click: true,
                scroll: true,
                tap: true
            },
            theme: 'thermacell',
            interactive: true
        });
    });

}

// Hubspot Forms
$(document).ready(function(){
    setTimeout(function(){
        var mailIcon = '<div class="newsletter-form-field-icon icon icon-mail"></div>';
        var form = $('.hbspt-form');
        var inputWrapper = form.find('.hs_email .input');
        var button = form.find('.hs_submit .hs-button');
        inputWrapper.find('input').attr('placeholder', 'your@email.com');
        inputWrapper.append(mailIcon);
        button.val('Sign Up')
    }, 400);
})


$(document).ready(function () {
    $('.spec-item .spec-key').each(function () {
        $(this).text($(this).text().substr($(this).text().indexOf("__") + 1, $(this).text().length));
        $(this).text($(this).text().replace("_", ""));
    });


    function pickVariantSpecs() {
        $('.spec-item')
        if ($('.product-options input[type=radio]').length) {
            var $tOpt = $('.product-options input[type=radio]');
            if ($tOpt) {
                $('.spec-item').css('display', 'none');
            }
            $('.product-options input[type="radio"]').each(function () {
                if ($(this).parent().hasClass('active')) {
                    $('.spec-' + $(this).attr('data-variant-id')).css('display', 'block');
                }
            });
        } else if ($('.single-option-selector').length) {
            var $tOpt = $('.desc.db');
            if ($tOpt) {
                $('.spec-item').css('display', 'none');
                $('.spec-' + $('.desc.db').attr('data-prod-id')).css('display', 'block');
            }
        } else {
            $('.spec-item').css('display', 'block');
        }
    }

    pickVariantSpecs();

    $(".single-option-selector").change(function () { pickVariantSpecs(); });
    $('.product-options .variant').click(function () {
        $('.spec-item').css('display', 'none');
        $('.spec-' + $(this).find('input').attr('data-variant-id')).css('display', 'block');
    });
});


$(".section-products .home-products form.product-form .variants .variant input").on("click", function () {
    var imagePath = $(this)[0].dataset.variantImage;
    var productId = $(this)[0].dataset.productId;
    $("#" + productId).attr('src', imagePath);
});

if ($(".module-wrapper.section-products").length > 0) {
    $(".variant.color--option").each(function () {
        variant_color = this.dataset.color;
        this.style.background = getVariantBkg(variant_color);
    });
}


/* =======================================

	            Tick Pro

======================================= */

if ($(".tick-blog-container").length > 0) {

    $(".tick-blog-container").find(".toggleArt").on('click', function () {
        var artId = this.dataset.id;
        $(".art-wrapper#article-content-" + artId).slideToggle('slow', function () {
            var tabWrapper = $(".tab__content");
            var activeTab = tabWrapper.find(".active");
            var activeTabHeight = activeTab.outerHeight();
            // Set height of wrapper on page load
            tabWrapper.height(activeTabHeight);
            $('html, body').animate({
                scrollTop: $("#article-content-" + artId).offset().top
            }, 2000);
        });
    });


    $("#subscribe-tick-pro").on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('#tickPro-form').offset().top
        }, 2500);
    });


}

// LAZY LOAD
(function () {
    var items = document.querySelectorAll(".lazy-image");
    if (window.IntersectionObserver) {
        function onEntry(entries, index) {
            entries.forEach(function (entry, index) {
                if (entry.isIntersecting === true) {
                    if (entry.target.dataset.bg_src) {
                        entry.target.classList.add("is-showing");
                        entry.target.style = `background-image: url(${entry.target.dataset.bg_src}); background-size: cover; background-position: 100% 80%;`;
                        observer.unobserve(entry.target);
                    }
                    if (entry.target.dataset.src) {
                        entry.target.classList.add("is-showing");
                        entry.target.src = `${entry.target.dataset["src"]}`;
                        observer.unobserve(entry.target);
                    }
                }
            });
        }

        var options = { threshold: [0.1] };
        var observer = new IntersectionObserver(onEntry, options);

        items.forEach(function (item, index) {
            observer.observe(item);
        });
    } else {
        items.forEach(function (item, index) {
            if (item.dataset.bg_src) {
                item.classList.add("is-showing");
                item.style = `background-image: url(${
                    item.dataset.bg_src
                    }); background-size: cover; background-position: 100% 80%;`;
            }
            if (item.dataset.src) {
                item.classList.add("is-showing");
                item.src = `${item.dataset["src"]}`;
            }
        });
    }
})();

//  FETCH YOUTUBE ON INTERACTION
(function(){
    var youtubeSetButton = document.getElementById("setVideo");
    var youtubeSetButtonMobile = document.getElementById("setVideoMobile");
    var urlToSet = youtubeSetButton.dataset.url;
    var urlToSetMobile = youtubeSetButton.dataset.url;

    youtubeSetButton.addEventListener('click', function(){
        document.querySelector("#youtubeEmbed").src = '//www.youtube.com/embed/'+urlToSet+'?rel=0&showinfo=1&vq=720/oembed?url=http://www.youtube.com/watch?v='+urlToSet+'&format=json'
    })
    youtubeSetButtonMobile.addEventListener('click', function(){
        document.querySelector("#youtubeEmbed").src = '//www.youtube.com/embed/'+urlToSetMobile+'?rel=0&showinfo=1&vq=720/oembed?url=http://www.youtube.com/watch?v='+urlToSet+'&format=json'
    })
})()

